import LanguagePack from "../../../../../../lib/html5-software-library/src/ranj/language/LanguagePack";
import AbstractPdfSection from "../../../../../../lib/html5-software-library/src/ranj/pdf/sections/AbstractPdfSection";
import PlayerModel from "../../../player/model/PlayerModel";
import ScoreService from "../../../score/controller/ScoreService";
import PersonalReportConfig from "../../model/PersonalReportConfig";

export default class ScoreSection extends AbstractPdfSection {
    /**
     * @constructor
     * @param {PersonalReportConfig} pdfConfig 
     * @param {LanguagePack} languagePack
     * @param {PlayerModel} playerModel
     * @param {ScoreService} scoreService
     */
    constructor(pdfConfig, languagePack, playerModel, scoreService) {
        super(pdfConfig.pageWidth);

        this._pdfConfig = pdfConfig;
        this._languagePack = languagePack;
        this._playerModel = playerModel;
        this._scoreService = scoreService;
    }

    async loadData() {
        const primaryTrackerScore = this._scoreService.getPrimaryTrackerScore();
        this._scoreText = primaryTrackerScore.getRoundedPercentage();
    }

    initialize() {
        super.initialize();

        const body1 = this._languagePack.getText('personalReport.score.body1');
        const decoratedBody1 = body1
            .replace(/{{playerName}}/g, this._playerModel.getTrimmedPlayerName())
            .replace(/{{score}}/g, this._scoreText);
        this.addText(decoratedBody1, {
            ...this._pdfConfig.getValue("elements.general.p"),
            size: 12,
        });

        const body2 = this._languagePack.getText('personalReport.score.body2');
        const decoratedBody2 = body2
            .replace(/{{playerName}}/g, this._playerModel.getTrimmedPlayerName())
            .replace(/{{score}}/g, this._scoreText);
        this.addText(decoratedBody2, this._pdfConfig.getValue("elements.general.div"));

        this.addPageBreak(false);
    }
}